/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import clsx from 'clsx'
import { Timeslot } from 'types/entities/Timeslot'

interface TimeslotProps {
    timeslot: Timeslot
}

export const TimeslotFilled = (props: TimeslotProps) => {
    const filledPercentage =
        (props.timeslot.persons_filled / props.timeslot.persons_max) * 100

    return (
        <div
            className={clsx(
                'TimeslotFilled',
                'w-full absolute inset-x-0 bottom-0',
                'bg-[var(--color-arbo-orange)]/30 dark:bg-[var(--color-arbo-orange)]/20',
                'z-0'
            )}
            style={{
                height: `${filledPercentage}%`,
            }}
        />
    )
}
